import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { RawLocation } from 'vue-router'

import './styles/index.scss'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { apolloProvider } from './vue-apollo'
import { Auth0Plugin } from './plugins/auth0'

Vue.config.productionTip = false
Vue.use(VueApollo)
Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_COLLAB_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_COLLAB_CLIENT_ID,
  audience: process.env.VUE_APP_AUTH0_BB_API_ID,
  onRedirectCallback: (appState: { targetUrl: RawLocation }) => {
    router.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname)
  }
})
const app = new Vue({
  router,
  store,
  vuetify,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')

/* eslint-disable @typescript-eslint/no-explicit-any */
if ((window as any).Cypress) {
  ;(window as any).app = app
}
/* eslint-enably @typescript-eslint/no-explicit-any */
